// removed by extract-text-webpack-plugin
module.exports = {"Arrow":"_35v1x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Arrow/Arrow.scss
// module id = 504
// module chunks = 0